import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IBillingState, BillingActionCreators, IBillingListResponse, IApplicationState, AppActionCreators } from '@nkr/store/index';
import { ISortBy, IBillingDetail, IBaseResponse } from '@nkr/models/index';
import { FormControl, FormGroup, Glyphicon } from 'react-bootstrap';
import PendingRow from './pending-row';
import ConfirmBilledManually from './confirm-billed-manually';
import { TableWrapper } from '../styles';
import { toast } from 'react-toastify';
import NoData from '../no-data';
import NavDonorCenter from '../nav-donor-center';
import { NavSubWrapper } from '../../styles';

interface IOwnProps {
    centerId: number,
    centerAlias: string
}

interface IStateProps {
    billing: IBillingState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getPendingList: (centerId: number, isRecipientCenter: boolean) => Promise<IBillingListResponse>,
    markBilledManually: (donorId: number, recipientId: number) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    dateRange: number,
    sortBy: ISortBy,
    billedManually: {
        show: boolean,
        data: IBillingDetail
    }
}

class Pending extends React.Component<TProps, IState> {
    readonly state: IState = {
        dateRange: 0,
        sortBy: { property: 'transplantDate', direction: 'asc' },
        billedManually: {
            show: false,
            data: null
        }
    }

    componentDidMount = () => {
        this.getData();
    }

    handleDateRangeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            dateRange: parseInt(e.currentTarget.value)
        });
    }

    handleStartBilling = (donorId: number) => {
        window.location.href = `/center/${this.props.centerId}/billing/view-edit/${donorId}`;
    }

    handleBilledManually = (donorId: number) => {
        let data = this.props.billing.pending.find(x => x.donorId == donorId);

        this.setState({
            billedManually: {
                show: true,
                data
            }
        });
    }

    handleConfirmedBilledManually = () => {
        let { donor, recipient, chainId, clusterNumber, positionNumber } = this.state.billedManually.data.billableNephrectomy;
        let swapNumber = `${chainId}/${clusterNumber}/${positionNumber}`;

        this.setState({
            billedManually: {
                show: true,
                data: null
            }
        }, () => {
            this.props.showLoading(`Swap ${swapNumber} is being set as billed manually, one moment please...`).then(() => {
                this.props.markBilledManually(donor.id, recipient.id).then(response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        this.props.getPendingList(this.props.centerId, false).then((response: IBillingListResponse) => {
                            toast.success(`Swap ${swapNumber} successfully set to billed manually`);
                        });
                    }
                });
            });
        });
    }

    handleCancelBilledManually = () => {
        this.setState({
            billedManually: {
                show: false,
                data: null
            }
        });
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);

        if (sortBy.property == property) {
            if (sortBy.direction == 'asc') {
                sortBy.direction = 'desc'
            } else {
                if (sortBy.direction == 'desc') {
                    sortBy = { property: '', direction: '' };
                }
            }
        } else {
            sortBy = { property, direction: 'asc' };
        }

        this.setState({
            sortBy
        });
    }

    getData = () => {
        this.props.showLoading('Getting pending, one moment please...').then(() => {
            this.props.getPendingList(this.props.centerId, false).then((response: IBillingListResponse) => {
                this.props.hideLoading();
            });
        });
    }

    getFilteredRows = () => {
        return this.props.billing.pending.filter(x => {
            let dateRange = this.state.dateRange > 0 ? moment(x.billableNephrectomy.transplantDate).isAfter(moment().addDays(-1 * this.state.dateRange)) : true;

            return dateRange;
        });
    }

    getSortedRows = () => {
        let { property, direction } = this.state.sortBy;
        let filteredRows = this.getFilteredRows();
        let sortedRows: IBillingDetail[] = [];

        if (property != '') {
            sortedRows = _.orderBy(filteredRows, item => {
                switch (property) {
                    case 'transplantDate': return moment(item.billableNephrectomy.transplantDate).format('YYMMDD');
                    case 'swapNumber': return parseInt(item.billableNephrectomy.chainId + '' + item.billableNephrectomy.clusterNumber + '' + item.billableNephrectomy.positionNumber);
                    case 'donorCenter': return item.billableNephrectomy.donor.center.alias;
                    case 'donorAlias': return item.billableNephrectomy.donor.alias;
                    case 'recipientAlias': return item.billableNephrectomy.recipient.alias;
                    case 'recipientCenter': return item.billableNephrectomy.recipient.center.alias;
                }

            }, [direction]);
        } else {
            sortedRows = filteredRows;
        }

        return sortedRows;
    }

    renderHeaderSort = (property: string) => {
        if (this.state.sortBy.property == property) {
            return <Glyphicon glyph={this.state.sortBy.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        const sortedRows = this.getSortedRows();
        const { show, data } = this.state.billedManually;

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 0px 5px' }}>
                    <NavSubWrapper verticalAlign='center' minTabWidth='85' fontSize='12px'>

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <FormGroup style={{ marginBottom: 0, marginRight: 20 }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ marginRight: 5 }}>Filter by Date Range:</div>
                                    <div>
                                        <FormControl
                                            componentClass='select'
                                            value={this.state.dateRange}
                                            onChange={this.handleDateRangeChange}
                                        >
                                            <option value={0}>- Show All -</option>
                                            <option value={90}>Past 90 Days</option>
                                            <option value={120}>Past 120 Days</option>
                                            <option value={180}>Past 180 Days</option>
                                            <option value={365}>Past Year</option>
                                            <option value={730}>Past 2 Years</option>
                                        </FormControl>
                                    </div>
                                </div>
                            </FormGroup>
                        </div>
                    </NavSubWrapper>

                    {sortedRows.length > 0 ?
                        <TableWrapper bordered condensed striped>
                            <thead>
                                <tr>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('transplantDate')}>TXP Date {this.renderHeaderSort('transplantDate')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('swapNumber')}>Swap # {this.renderHeaderSort('swapNumber')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorCenter')}>Donor Center {this.renderHeaderSort('donorCenter')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorAlias')}>Donor Alias {this.renderHeaderSort('donorAlias')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('recipientCenter')}>Recipient Center {this.renderHeaderSort('recipientCenter')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('recipientAlias')}>Recipient Alias {this.renderHeaderSort('recipientAlias')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('claimType')}>Claim Type {this.renderHeaderSort('claimType')}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedRows.map((item, index) =>
                                    <PendingRow
                                        key={index}
                                        data={item}
                                        onStartBilling={this.handleStartBilling}
                                        onBilledManually={this.handleBilledManually}
                                    />
                                )}
                            </tbody>
                        </TableWrapper>
                        :
                        <NoData message='No charges are pending at your center...' />
                    }
                </div>

                <ConfirmBilledManually
                    show={show}
                    data={data}
                    onConfirmed={this.handleConfirmedBilledManually}
                    onCancel={this.handleCancelBilledManually}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        billing: appState.billing
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getPendingList: (centerId, isRecipientCenter) => { return dispatch(BillingActionCreators.getPendingList(centerId, isRecipientCenter)); },
        markBilledManually: (donorId, recipientId) => { return dispatch(BillingActionCreators.markBilledManually(donorId, recipientId)); }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Pending);